import { Model } from 'infra/model'
import { WorkspaceWithBundles as WorkspaceWithBundlesProto } from '@taxfyle/api-internal/internal/bundle_pb'
import { computed, observable, makeObservable } from 'mobx'
import WorkspaceStore from 'iam/WorkspaceStore'
import Workspace from 'iam/models/Workspace'

export default class WorkspaceWithBundles extends Model<
  WorkspaceWithBundlesProto.AsObject,
  WorkspaceWithBundles
> {
  @observable workspaceId = ''

  constructor(private workspaceStore: WorkspaceStore) {
    super()
    makeObservable(this)
  }

  @computed
  get workspace() {
    return (
      this.workspaceStore.workspaces.get(this.workspaceId) || Workspace.none
    )
  }

  parse(
    json: Partial<WorkspaceWithBundlesProto.AsObject>
  ): Partial<WorkspaceWithBundles> {
    this.workspaceStore.fetch(json.workspaceId)

    return {
      workspaceId: json.workspaceId,
    }
  }
}
